import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-yoomoney",
  "use": "icon-yoomoney-usage",
  "viewBox": "0 0 57 40",
  "content": "<symbol viewBox=\"0 0 57 40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-yoomoney\"><path d=\"M36.33 0c-11.14 0-20 8.987-20 20 0 11.14 8.987 20 20 20 11.012 0 20-8.987 20-20s-8.988-20-20-20zm0 27.342c-4.051 0-7.47-3.418-7.47-7.469 0-4.05 3.419-7.468 7.47-7.468 4.05 0 7.468 3.418 7.468 7.468-.127 4.178-3.418 7.469-7.469 7.469zM16.203 5.696V34.81h-7.09L0 5.696h16.203z\" fill=\"#666666\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol